import "regenerator-runtime/runtime";
import Vue from "vue";
import VueCompositionAPI from "@vue/composition-api";
import App from "./App.vue";
import router from "./router/routerSite.js";
import store from "./store";
import Vuex from "vuex";
import VueMeta from "vue-meta";
import { initPostHog } from "./utils/posthog";
import {
  isLoggedIn,
  promptLoginModal,
  PRODUCT_DETAIL_ROUTE_NAMES,
} from "./utils/affiliatePurchase";
Vue.use(Vuex);
Vue.use(VueCompositionAPI);
window.$ = window.jQuery = require("jquery");

initPostHog();

import "vue-select-image/dist/vue-select-image.css";
import "bootstrap";

//bootstrapvue
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
Vue.use(BootstrapVue);
import "bootstrap-vue/dist/bootstrap-vue.css";
//end
//Sweet alert
import VueSweetalert2 from "vue-sweetalert2";
Vue.use(VueSweetalert2);
import "sweetalert2/dist/sweetalert2.min.css";
//End of sweet alert
//Toggle Button
import ToggleButton from "vue-js-toggle-button";

Vue.use(ToggleButton);
//End of toggle buttion

Vue.use(VueMeta);

Vue.config.productionTip = false;
router.beforeEach(async (to, from, next) => {
  // Redirect to Dashboard if logged in — but skip the assistant preview route.
  if (to.path !== "/assistant" && localStorage.getItem("userData") !== null) {
    let userData = JSON.parse(localStorage.getItem("userData"));
    if (userData.customer) {
      window.location.href = "home";
    }
  }

  if (PRODUCT_DETAIL_ROUTE_NAMES.indexOf(to.name) !== -1 && !isLoggedIn()) {
    if (from.name) {
      promptLoginModal();
      next(false);
    } else {
      next({ path: "/browse", replace: true });
      window.setTimeout(function() {
        promptLoginModal();
      }, 0);
    }
    return;
  }

  // ##Redirect to Dashboard if logged in
  // document.title = process.env.VUE_APP_NAME + " : " + to.meta.title;
  next();
});

router.afterEach(function(to) {
  if (typeof window.gtag === "function") {
    window.gtag("config", "G-2LPSTZ6K46", {
      page_path: to.fullPath,
    });
  }
});

new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
